export default __webpack_public_path__ + "static/media/header.b8f4025d.png";